import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import TicTacToe from './TicTacToe.js';
import TrafficLights from './TrafficLights.js';
import CatsAndDogs from './CatsAndDogs.js';
import Hex from './Hex.js';
import Checkers from './Checkers.js';
import NineMensMorris from './NineMensMorris.js';
import FoxAndGeese from './FoxAndGeese.js';
import Domineering from './Domineering.js';
import AtariGo from './AtariGo.js';
import Amazons from './Amazons.js';
import Breakthrough from './Breakthrough.js';
import Aboyne from './Aboyne.js';
import AdditionsSubtractions from './AdditionsSubtractions.js';
import MissingOperand from './MissingOperand.js';

// Sections of the site. Each section has a list of items (games or activities).
// Adding a new topic (e.g. 2.º Ano, Geometria) is just a matter of adding
// another entry here and importing the corresponding component.
const SECTIONS = [
	{
		id: 'year1',
		title: '1.º Ano',
		description: 'Atividades de matemática para o 1.º ano de escolaridade.',
		items: [
			{ id: 'additions-subtractions', title: 'Adições e Subtrações', component: AdditionsSubtractions },
			{ id: 'missing-operand', title: 'Número em Falta', component: MissingOperand },
		],
	},
	{
		id: 'boardgames',
		title: 'Jogos de Tabuleiro',
		description: 'Jogos clássicos de estratégia para dois jogadores.',
		items: [
			{ id: 'tictactoe', title: 'Jogo do Galo', component: TicTacToe },
			{ id: 'trafficlights', title: 'Semáforo', component: TrafficLights },
			{ id: 'catsanddogs', title: 'Gatos e Cães', component: CatsAndDogs },
			{ id: 'hex', title: 'Hex', component: Hex },
			{ id: 'checkers', title: 'Damas', component: Checkers },
			{ id: 'ninemensmorris', title: 'Moinho', component: NineMensMorris },
			{ id: 'foxandgeese', title: 'Fox and Geese', component: FoxAndGeese },
			{ id: 'domineering', title: 'Dominório', component: Domineering },
			{ id: 'atarigo', title: 'Atari Go', component: AtariGo },
			{ id: 'amazons', title: 'Amazons', component: Amazons },
			{ id: 'breakthrough', title: 'Breakthrough', component: Breakthrough },
			{ id: 'aboyne', title: 'Aboyne', component: Aboyne },
		],
	},
];

const App = () => {
	const [sectionId, setSectionId] = useState(null);
	const [itemId, setItemId] = useState(null);

	// Top-level menu: pick a section (e.g. 1.º Ano, Jogos de Tabuleiro).
	if (!sectionId) {
		return (
			<div className="game-container">
				<h1 className="game-title">Desafio Aceite</h1>
				<h2 className="config-subtitle">Matemática</h2>
				<div className="game-menu">
					{SECTIONS.map((section) => (
						<button
							key={section.id}
							className="menu-button"
							onClick={() => setSectionId(section.id)}
						>
							{section.title}
						</button>
					))}
				</div>
			</div>
		);
	}

	const section = SECTIONS.find((s) => s.id === sectionId);

	// Section menu: pick an item inside the chosen section.
	if (!itemId) {
		return (
			<div className="game-container">
				<button className="back-button" onClick={() => setSectionId(null)}>
					← Voltar
				</button>
				<h1 className="game-title">{section.title}</h1>
				{section.description && (
					<h2 className="config-subtitle">{section.description}</h2>
				)}
				<div className="game-menu">
					{section.items.map((item) => (
						<button
							key={item.id}
							className="menu-button"
							onClick={() => setItemId(item.id)}
						>
							{item.title}
						</button>
					))}
				</div>
			</div>
		);
	}

	const item = section.items.find((i) => i.id === itemId);
	const ItemComponent = item.component;

	return (
		<div>
			<button className="back-button" onClick={() => setItemId(null)}>
				← Voltar
			</button>
			<ItemComponent />
		</div>
	);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
